import React from 'react'
import '../Project.css';
import Image1 from '../../Gemco-Website-Images/projects/Dubai_Hills_regional_Mall.webp';

const Project_one = () => {

  return (
    <>
   
         <div className='project_1_work' id="workBanner">
   
           <div className="container project_our_work">
   
             <div className="heading">
               <h1>Dubai Hills Regional Mall</h1>
             </div>
   
             <hr></hr>
             <div className='project_section'>
               <div className="project_section_content">
                 <h1 className="project_scope">Scope of Work</h1>
                 <p>A major regional shopping destination at the heart of the Dubai Hills Estate master community developed by Emaar and
                    Meraas. The mall spans 200,000+ sqm of GLA and serves as the retail and lifestyle anchor for one of Dubai's largest
                    integrated residential developments.</p>
                 <p>MAIN CONTRACTOR : ALEC</p>
                 <p>MEP CONTRACTOR : -</p>
                 <p>GEMCO SCOPE OF WORKS : Pre-insulated underground CHW pipework and MEP works</p>
                 {/* <h2 className="project_years">2014 – 2022</h2> */}
               </div>
               <div className='project_1_card'>
                 <img className="project_one_image" width="500" height="300" src={Image1} alt="Project" />
               </div>
             </div>
           </div>
         </div>
   
       </>

  )
}

export default Project_one